import issueDescription from "./issue_description";
import reason from "./reason";

export default {
  issueDescription,
  reason,
  displayName: "Topic Present WITHOUT ANY Specified Parameter",
  order: 320,
};
